const isDevelopment = process.env.REACT_APP_NODE_TYPE === 'development';
const API_HOST = process.env.REACT_APP_API_URL;
const NVIDIA_GPU_API_HOST = process.env.REACT_APP_NVIDIA_GPU_API_URL || '18.208.58.92';
const GCP_WELLS_FARGO_API_HOST = process.env.REACT_APP_GCP_WELLS_FARGO_API_URL || '34.135.102.57';
const httpProtocol = 'https';
const PRODUCTION_ENDPOINTS = {
  SQL: `${httpProtocol}://${API_HOST}/api/v1/sql`,
  CUSTOMERS: `${httpProtocol}://${API_HOST}/api/v1/pool`,
  EXPORT: `${httpProtocol}://${API_HOST}`,
  AUTH: `${httpProtocol}://${API_HOST}/api/v1/sql`,
  NOVA: `${httpProtocol}://${API_HOST}/api/v1/nova`,
  SQL_AGENT: `${httpProtocol}://${API_HOST}/api/v1/sql_agent`,
  CHART: `${httpProtocol}://${API_HOST}`,
  CUSTOMER_SUMMARY: `${httpProtocol}://${API_HOST}/api/v1/cust_summary`,
  RAG: `${httpProtocol}://${API_HOST}/api/v1/rag_agent`,
  UPLOAD: `${httpProtocol}://${API_HOST}/api/v1/doc_loader`,
  GROUPS: `${httpProtocol}://${API_HOST}/api/v1/pool`,
  AUDIT: `${httpProtocol}://${API_HOST}/api/v1/audit`,
  CLUSTER: `${httpProtocol}://${NVIDIA_GPU_API_HOST}`,
  METADATA: `${httpProtocol}://${API_HOST}`,
  JAMBA: `${httpProtocol}://${API_HOST}`,
  RETAIL: `${httpProtocol}://${NVIDIA_GPU_API_HOST}`,
  SOCKET: `${httpProtocol}://${API_HOST}`,
  AEM_RAG: `${httpProtocol}://${API_HOST}/api/v1/page_authoring`,
  EXPORT_USE_CASE: `${httpProtocol}://${API_HOST}/api/v1/build_use_case`,
  SUM_AUDIT: `${httpProtocol}://${API_HOST}/api/v1/responsible_ai/audits`,
  TTS: `${httpProtocol}://${NVIDIA_GPU_API_HOST}`,
  AUDIO: `${httpProtocol}://${NVIDIA_GPU_API_HOST}`,
  PROCESS_TRACKER: `${httpProtocol}://${API_HOST}/services`,
  PIPELINE_PROCESS_TRACKER: `${httpProtocol}://${API_HOST}/api/logs`,
  GUARD: `${httpProtocol}://${API_HOST}`,
  NEWS: `${httpProtocol}://${API_HOST}/api/news`,
  AGENTS: `${httpProtocol}://${API_HOST}/api/v1/agents`,
  EVAL: `${httpProtocol}://${API_HOST}/api/v1/model-eval`,
  NOVA_INGESTION: `${httpProtocol}://${API_HOST}/api/v1/ingestion`,
  SYNTHIQ: `${httpProtocol}://${API_HOST}/api/v1/synthetic_data`,
  NOVA_V2: `${httpProtocol}://${API_HOST}/api/nova`,
  NOVA_V2_RUN: `${httpProtocol}://${API_HOST}/api/v1/nova`,
  PRESENTATION_GENERATOR: `${httpProtocol}://${API_HOST}/api/v1/presentation`
};


const DEVELOPMENT_ENDPOINTS = {
  SQL: `http://${API_HOST}:5022/api/v1/sql`,
  CUSTOMERS: `http://${API_HOST}:8015/api/v1/pool`,
  EXPORT: `http://${API_HOST}:5007`,
  AUTH: `http://${API_HOST}:5022/api/v1/sql`,
  NOVA: `http://${API_HOST}:5010/api/v1/nova`,
  SQL_AGENT: `http://${API_HOST}:5009/api/v1/sql_agent`,
  CHART: `http://${API_HOST}:8001`,
  CUSTOMER_SUMMARY: `http://${API_HOST}:8005/api/v1/cust_summary`,
  RAG: `http://${API_HOST}:5011/api/v1/rag_agent`,
  UPLOAD: `http://${API_HOST}:8009/api/v1/doc_loader`,
  GROUPS: `http://${API_HOST}:8015/api/v1/pool`,
  AUDIT: `http://${API_HOST}:8012/api/v1/audit`,
  CLUSTER: `http://${NVIDIA_GPU_API_HOST}:8001`,
  METADATA: `http://${API_HOST}:8013`,
  JAMBA: `http://${API_HOST}:5001`,
  RETAIL: `http://${NVIDIA_GPU_API_HOST}:8007`,
  SOCKET: `http://${API_HOST}:5000`,
  AEM_RAG: `http://${API_HOST}:8008/api/v1/page_authoring`,
  CG: `http://${API_HOST}:5004`,
  EXPORT_USE_CASE: `http://${API_HOST}:5021/api/v1/build_use_case`,
  SUM_AUDIT: `http://${API_HOST}:8083/api/v1/responsible_ai/audits`,
  TTS: `http://${NVIDIA_GPU_API_HOST}:8080`,
  AUDIO: `http://${NVIDIA_GPU_API_HOST}:8000`,
  PROCESS_TRACKER: `http://${API_HOST}:3006/services`,
  PIPELINE_PROCESS_TRACKER:`http://${API_HOST}:8011/api/logs`,
  GUARD: `http://${API_HOST}:8060`,
  NEWS: `http://${API_HOST}:5023/api/news`,
  AGENTS: `http://${API_HOST}:5013/api/v1/agents`,
  EVAL: `http://${API_HOST}:8070/api/v1/model-eval`,
  NOVA_INGESTION: `http://${API_HOST}:8004/api/v1/ingestion`,
  SYNTHIQ: `http://${API_HOST}:8033/api/v1/synthetic_data`,
  NOVA_V2: `http://${API_HOST}:5113/api/nova`,
  NOVA_V2_RUN: `http://${API_HOST}:5113/api/v1/nova`,
  PRESENTATION_GENERATOR: `http://${API_HOST}:8030/api/v1/presentation`
};

export const API_ENDPOINTS = isDevelopment ? DEVELOPMENT_ENDPOINTS : PRODUCTION_ENDPOINTS;
// console.log('API_ENDPOINTS:', API_ENDPOINTS);
export const buildApiUrl = (service, path = '') => {
  const baseUrl = API_ENDPOINTS[service];
  if (!baseUrl) {
    console.error(`Unknown API service: ${service}`);
    return '';
  }
  return `${baseUrl}${path}`;
};

export const buildSqlUrl = (endpoint = '') => {
  return buildApiUrl('SQL', endpoint);
};

export const buildCustomerUrl = (endpoint = '') => {
  return buildApiUrl('CUSTOMERS', endpoint);
};

export const buildExportUrl = (endpoint = '') => {
  return buildApiUrl('EXPORT', endpoint);
};

export const buildAuthUrl = (endpoint = '') => {
  return buildApiUrl('AUTH', endpoint);
};

export const buildNovaUrl = (endpoint = '') => {
  return buildApiUrl('NOVA', endpoint);
};

export const buildGroupsUrl = (endpoint = '') => {
  return buildApiUrl('GROUPS', endpoint);
};

export const customerSummaryUrl = (endpoint = '') => {
  return buildApiUrl('CUSTOMER_SUMMARY', endpoint);
}

export const buildSegmentationUrl = (endpoint = '') => {
  return buildApiUrl('CLUSTER', endpoint);
};

export const buildMetadataExtractionUrl = (endpoint = '') => {
  return buildApiUrl('METADATA', endpoint);
}

export const buildNovaIngestionUrl = (endpoint = '') => {
  return buildApiUrl('NOVA_INGESTION', endpoint);
};